export type ITripDetailsParamNameLegacy = "tripId" | "hotelId";
export const tripDetailsParamNamesLegacy: SameRecord<ITripDetailsParamNameLegacy> = {
  tripId: "tripId",
  hotelId: "hotelId",
};
export const TRIP_DETAILS_PATH_LEGACY = `/my-trips/:${tripDetailsParamNamesLegacy.hotelId}/:${tripDetailsParamNamesLegacy.tripId}`;

export type ITripDetailsParamName = "tripKey" | "hotelId";
export const tripDetailsParamNames: SameRecord<ITripDetailsParamName> = {
  tripKey: "tripKey",
  hotelId: "hotelId",
};
export const TRIP_DETAILS_PATH = `/my-trips/:${tripDetailsParamNames.hotelId}/:${tripDetailsParamNames.tripKey}`;
